import { CallVolunteerForm } from '../components/callerForm/CallerFormModal';
import { apiInstance } from './apiInstance';

export const createContact = async (payload: CallVolunteerForm) => {
  return await apiInstance.post('call-volunteer', payload);
};
